export const administrationAccountsSiteLocationLicenceDetails = {
    template: require('./administration-accounts-site-location-licence-details.html'),
    controller: 'AdministrationAccountsSiteLocationLicenceDetailsController'
};
